const rankingRouter = {
  path: '',
  component: () => import('@/layout'),
  children: [
    {
      path: '/leaderboard/livelist',
      name: 'LeaderboardLivelist',
      meta: { title: '视频排行榜' },
      component: () =>
        import(/* webpackChunkName: "ranking" */ '@/pages/leaderboard/pages/shopkeeperLlive')
    },
    {
      path: '/rankList',
      name: 'rankListIndex',
      meta: { title: '排行榜' },
      component: () => import(/* webpackChunkName: "ranking" */ '@/pages/rankList/index'),
    }
  ]
}

export default rankingRouter
